import {createUseStyles} from 'react-jss'

export default createUseStyles({
  bg: {
    width: '100%',
    minHeight: '100vh',
    display: "flex",
    backgroundImage: "linear-gradient(to right, #004f9f , #75baff);",
    justifyContent: "center",
    alignItems: 'center'
  },
  form: {
    width: '100%',
    maxWidth: 400,
    backgroundColor: 'white',
    borderRadius: 7,
    boxShadow: '0 3px 6px rgba(0,0,0,0.3)',
    padding: 30,
    margin: 10,
    zIndex: 100,
    '& h2': {
      fontSize: 25,
      marginBottom: 20,
      color: 'rgba(0,0,0,0.7)'
    },
    '& a': {
      color: '#004f9f',
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline'
      }
    }
  },
  logo: {
    position: "fixed",
    height: 100,
    bottom: 10,
    left: 10
  },
  remember: {
    display: 'flex',
    width: 'auto',
    marginBottom: 10,
    '& input': {
      height: 'auto',
      marginLeft: 10
    }
  },
  signUp: {
    backgroundColor: '#949494 !important'
  },

  otheropt: {
    marginTop: 20,
    color: 'rgba(0,0,0,0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection :'column',
    
  },

  loading: {
    height: '100vh !important'
  },


  googleBtn: {
    width: "100%",
    marginTop: 20,
  }
})